import { useState } from 'react';

export const useUpdateBrand = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const updateBrandHook = async (brand, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}qalbox-admin-brand-service/v1/update/`,
        {
          method: "PUT",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
          redirect: "follow",
          referrerPolicy: "no-referrer",
          body: JSON.stringify({
            brand: brand,
            uuid: brand.uuid,
          }),
        }
      );

      const json = await response.json();

      if (json.success) {
        setSuccess(true);
        handleUpdate(json);
      } else {
        setError("Failed to create brand");
      }
    } catch (error) {
      setError("An error occurred while creating the brand");
    } finally {
      setLoading(false);
    }
  };

  return [ updateBrandHook, loading, error, success ];
};